module.exports = __webpack_public_path__ + "img/IMG_1539_L.465f6ee3.webp";